export class GcpRestoreAccountAttributes {
    'serviceAccount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccount",
            "baseName": "serviceAccount",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
